import { useMutation } from '@tanstack/react-query';
import { useAderenciaPrecosStore } from '../AderenciaPrecos.store';
import { useDebounce } from '../../../../../hooks';

import * as service from '../services';
import { FiltroSalvoResponse } from '../types';

export const useAderenciaPrecosSavedFilter = () => {
  const debounce = useDebounce();

  const { setAderenciaPrecosState } = useAderenciaPrecosStore();

  const successAction = (type: string, data: any) => {
    if (!data?.data) return;

    const content = type === 'search' ? data.data : (data.data.content ?? []);

    const list =
      content?.map((item: FiltroSalvoResponse) => ({
        value: item.idFiltroSalvo,
        label: item.nomeFiltroSalvo,
      })) ?? [];

    setAderenciaPrecosState('savedFilterSelectList', list);
    setAderenciaPrecosState('savedFilterResponseData', content);
  };

  const getSavedFilters = async () => {
    const resp = await service.getAderenciaPrecosSavedFilterList();
    return resp;
  };

  const getSearchSavedFilters = async (query: string) => {
    debounce(async () => {
      const resp = await service.getAderenciaPrecosSavedFilterSearch(query);
      if (resp?.status === 200) {
        successAction('search', resp);
      }
    });
  };

  const mutate = useMutation({
    mutationFn: getSavedFilters,
    onSuccess: data => successAction('list', data),
  });

  return {
    handleGetSavedFilterList: mutate.mutateAsync,
    handleGetSavedFilterSearch: getSearchSavedFilters,
  };
};
